import React from "react";

export const IconViewLayoutGrid2x = (props) => {
    return (
        <div className="flex flex-col items-center"
             {...props}
        >
            <svg
                xmlns="http://www.w3.org/2000/svg"
                version="1.1"
                viewBox="0 0 103.005 102.935"
            >
                <g transform="translate(237.556 -138.941)">
                    <g>
                        <g>
                            <g transform="translate(-19.955 -8.137)">
                                <path
                                    fill="currentColor"
                                    strokeWidth="1"
                                    d="M37.893 0C16.9 0 0 17.575 0 39.404v105.717c0 21.83 16.9 39.402 37.893 39.402H146.63c20.993 0 37.892-17.572 37.892-39.402V39.404c0-21.83-16.9-39.404-37.892-39.404zm204.785 0c-20.993 0-37.893 17.575-37.893 39.404v105.717c0 21.83 16.9 39.402 37.893 39.402h108.736c20.993 0 37.895-17.572 37.895-39.402V39.404C389.309 17.574 372.407 0 351.414 0zM37.893 204.523C16.9 204.523 0 222.098 0 243.928v105.717c0 21.83 16.9 39.402 37.893 39.402H146.63c20.993 0 37.892-17.573 37.892-39.402V243.928c0-21.83-16.9-39.405-37.892-39.405zm204.785 0c-20.993 0-37.893 17.575-37.893 39.405v105.717c0 21.83 16.9 39.402 37.893 39.402h108.736c20.993 0 37.895-17.573 37.895-39.402V243.928c0-21.83-16.902-39.405-37.895-39.405z"
                                    transform="matrix(.26458 0 0 .26458 -217.6 147.078)"
                                ></path>
                            </g>
                        </g>
                    </g>
                </g>
            </svg>

        </div>
    )
}
export const IconViewLayoutGrid3x = (props) => {
    return (
        <div className="flex flex-col items-center justify-center h-full"
             {...props}
        >
            <svg
                xmlns="http://www.w3.org/2000/svg"
                version="1.1"
                viewBox="0 0 157.187 102.935"
            >
                <g transform="translate(237.556 -138.941)">
                    <g>
                        <g>
                            <g transform="translate(-19.955 -8.137)">
                                <path
                                    fill="currentColor"
                                    strokeWidth="1"
                                    d="M37.893 0C16.9 0 0 17.575 0 39.404v105.717c0 21.83 16.9 39.402 37.893 39.402H146.63c20.993 0 37.892-17.572 37.892-39.402V39.404c0-21.83-16.9-39.404-37.892-39.404zm204.785 0c-20.993 0-37.893 17.575-37.893 39.404v105.717c0 21.83 16.9 39.402 37.893 39.402h108.736c20.993 0 37.895-17.572 37.895-39.402V39.404C389.309 17.574 372.407 0 351.414 0zm204.785 0c-20.993 0-37.895 17.575-37.895 39.404v105.717c0 21.83 16.902 39.402 37.895 39.402h108.736c20.993 0 37.893-17.572 37.893-39.402V39.404c0-21.83-16.9-39.404-37.893-39.404zM37.893 204.523C16.9 204.523 0 222.098 0 243.928v105.717c0 21.83 16.9 39.402 37.893 39.402H146.63c20.993 0 37.892-17.573 37.892-39.402V243.928c0-21.83-16.9-39.405-37.892-39.405zm204.785 0c-20.993 0-37.893 17.575-37.893 39.405v105.717c0 21.83 16.9 39.402 37.893 39.402h108.736c20.993 0 37.895-17.573 37.895-39.402V243.928c0-21.83-16.902-39.405-37.895-39.405zm204.785 0c-20.993 0-37.895 17.575-37.895 39.405v105.717c0 21.83 16.902 39.402 37.895 39.402h108.736c20.993 0 37.893-17.573 37.893-39.402V243.928c0-21.83-16.9-39.405-37.893-39.405z"
                                    transform="matrix(.26458 0 0 .26458 -217.6 147.078)"
                                ></path>
                            </g>
                        </g>
                    </g>
                </g>
            </svg>

        </div>
    )
}
export const IconViewLayoutGrid4x = (props) => {
    return (
        <div className="flex flex-col items-center"
             {...props}
        >

            <svg
                xmlns="http://www.w3.org/2000/svg"
                version="1.1"
                viewBox="0 0 211.37 102.936"
            >
                <g transform="translate(237.556 -138.941)">
                    <g>
                        <g>
                            <g transform="translate(-19.955 -8.137)">
                                <path
                                    fill="currentColor"
                                    strokeWidth="1"
                                    d="M37.893 0C16.9 0 0 17.575 0 39.404v105.717c0 21.83 16.9 39.402 37.893 39.402H146.63c20.993 0 37.892-17.572 37.892-39.402V39.404c0-21.83-16.9-39.404-37.892-39.404H37.893zm204.785 0c-20.993 0-37.893 17.575-37.893 39.404v105.717c0 21.83 16.9 39.402 37.893 39.402h108.736c20.993 0 37.895-17.572 37.895-39.402V39.404C389.309 17.574 372.407 0 351.414 0H242.678zm204.785 0c-20.993 0-37.895 17.575-37.895 39.404v105.717c0 21.83 16.902 39.402 37.895 39.402h108.736c20.993 0 37.893-17.572 37.893-39.402V39.404c0-21.83-16.9-39.404-37.893-39.404H447.463zm204.783 0c-20.993 0-37.892 17.575-37.892 39.404v105.717c0 21.83 16.9 39.402 37.892 39.402h108.738c20.993 0 37.893-17.572 37.893-39.402V39.404c0-21.83-16.9-39.404-37.893-39.404H652.246zM37.893 204.523C16.9 204.523 0 222.098 0 243.928v105.717c0 21.83 16.9 39.402 37.893 39.402H146.63c20.993 0 37.892-17.573 37.892-39.402V243.928c0-21.83-16.9-39.405-37.892-39.405H37.893zm204.785 0c-20.993 0-37.893 17.575-37.893 39.405v105.717c0 21.83 16.9 39.402 37.893 39.402h108.736c20.993 0 37.895-17.573 37.895-39.402V243.928c0-21.83-16.902-39.405-37.895-39.405H242.678zm204.785 0c-20.993 0-37.895 17.575-37.895 39.405v105.717c0 21.83 16.902 39.402 37.895 39.402h108.736c20.993 0 37.893-17.573 37.893-39.402V243.928c0-21.83-16.9-39.405-37.893-39.405H447.463zm204.783 0c-20.993 0-37.892 17.575-37.892 39.405v105.717c0 21.83 16.9 39.402 37.892 39.402h108.738c20.993 0 37.893-17.573 37.893-39.402V243.928c0-21.83-16.9-39.405-37.893-39.405H652.246z"
                                    transform="matrix(.26458 0 0 .26458 -217.6 147.078)"
                                ></path>
                            </g>
                        </g>
                    </g>
                </g>
            </svg>

        </div>
    )
}